import React from "react";
import TailwindPageWrapper from "../components/generic/TailwindPageWrapper";
import Hero from "../components/generic/Hero";
import ChinWooOverview from "../components/chinWooDetailsPage/ChinWooOverview";
import Timeline from "../components/chinWooDetailsPage/Timeline";
import ChinWooWorldMap from "../components/chinWooDetailsPage/ChinWooWorldMap";
import ChinWooWorldChampionships from "../components/chinWooDetailsPage/ChinWooWorldChampionships";

function ChinWooDetailsPage() {
  return (
    <TailwindPageWrapper>
      <div className="-mt-24">
        <Hero
          className="hero-chinwoo-details"
          site_call="chinwoo_details_page"
          next_section="chinwoo-overview"
        />
        <ChinWooOverview />
        <Timeline />
        <ChinWooWorldMap />
        <ChinWooWorldChampionships />
      </div>
    </TailwindPageWrapper>
  );
}

export default ChinWooDetailsPage;
